/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsForcePasswordChange
 */
export interface MelcoModelsForcePasswordChange {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsForcePasswordChange
     */
    new_password?: string | null;
}

export function MelcoModelsForcePasswordChangeFromJSON(json: any): MelcoModelsForcePasswordChange {
    return MelcoModelsForcePasswordChangeFromJSONTyped(json, false);
}

export function MelcoModelsForcePasswordChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsForcePasswordChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'new_password': !exists(json, 'new_password') ? undefined : json['new_password'],
    };
}

export function MelcoModelsForcePasswordChangeToJSON(value?: MelcoModelsForcePasswordChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_password': value.new_password,
    };
}


